// extracted by mini-css-extract-plugin
module.exports = {"container":"feature-card_container__JHG4i","card":"feature-card_card__2HouB","title":"feature-card_title__pLMTs","body":"feature-card_body__NCpQv"};